import { Shape, Vector2 } from 'three';

export class ShapeHelper {
  static createOutlineShape(length: number, width: number, margin: number): Shape {
    const outerShape = new Shape([
      new Vector2(-length / 2 - margin, -width / 2 - margin),
      new Vector2(length / 2 + margin, -width / 2 - margin),
      new Vector2(length / 2 + margin, width / 2 + margin),
      new Vector2(-length / 2 - margin, width / 2 + margin),
    ]);

    const innerShape = new Shape([
      new Vector2(-length / 2, -width / 2),
      new Vector2(length / 2, -width / 2),
      new Vector2(length / 2, width / 2),
      new Vector2(-length / 2, width / 2),
    ]);

    outerShape.holes.push(innerShape);
    return outerShape;
  }
}